<template>
	<vx-card class="ticket-payment-info">
		<b>{{ $t('paymentDetails') }}</b>
		<div class="stages">
			<div
				 v-for="(stage,index) in stages"
				 :key="index"
				 class="stage"
			>
				<div class="head">
					<span class="stage__title">{{ $t('stage') }} {{ index+1 }}</span>

					<div v-if="isReadOnly" class="vx-row">
						<div class="vx-col">
							<span
								:class="`${$getStatusColor(stage.status)} status`"
							>{{ $getStatus(stage.status) }}</span>
						</div>
					</div>
				</div>
				<div class="vx-row stage-list">
					<div class="vx-col sm:w-1/3 w-full stage-list__item">
						<vs-input
							:disabled="isReadOnly"
							:label="$t('price')"
							v-model="stage.price_client"
							@input="changeStage(stage)"
						/>
					</div>
					<div class="vx-col sm:w-1/3 w-full stage-list__item">
						<vs-input
							:disabled="isReadOnly"
							:label="$t('pagesAmountShort')"
							v-model="stage.pages_number"
							@input="changeStage(stage)"
						/>
					</div>
					<div class="vx-col sm:w-1/3 w-full stage-list__item">
						<div
							class="vs-component vs-con-input-label vs-input vs-input-primary"
						>
							<label class="vs-input--label">{{ $t('dueDate') }}</label>
							<div class="vs-con-input"></div>
							<vs-datepicker
								:disabled="isReadOnly"
								:to="minDate"
								v-model="stage.due_date"
								@change="changeStage(stage)"
								format="dd.MM.yyyy"
							/>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="vx-row justify-between">
			<div v-if="canShowTerminate" class="vx-col mt-3">
				<vs-button
					color="success"
					@click="$emit('openTerminatePopup')"
				>{{ $t('completeOrder') }}</vs-button>
			</div>
			<div class="vx-col mt-3 flex items-center">
				<b>{{ `${$t('totalPaymentSum')}: ${totalSumOutput}` }}</b>
			</div>
		</div>
	</vx-card>
</template>

<script>
import SetStageFailedPopup from "@/components/dialogs/SetStageFailedPopup";
import SetStageDonePopup from "@/components/dialogs/SetStageDonePopup";
import vSelect from "vue-select";
import moment from "moment";
import databaseManager from "@/mixins/databaseManager";
import notifier from "@/mixins/notifier";

export default {
	name: "CardStages",
	mixins: [databaseManager, notifier],
	props: {
		orderId: { default: -1, 	type: Number },
		stages:  { default: [] },
		status:  { default: "new", 	type: String },
		works:   { default: [] },
	},
	components: {
		SetStageFailedPopup,
		SetStageDonePopup,
		vSelect,
	},
	data() {
		return {
			recommendedPrice: 0,
			failedPopupActive: false,
			donePopupActive: false,
			updateTimeout: null,
		}
	},
	computed: {
		minDate() {
			return new Date();
		},
		isReadOnly() {
			return true;
		},
		totalSum(){
			return  this.stages.reduce((acc,el)=>{
				return acc + Number(el.price_client);
			},0)
		},
		totalSumOutput() {
			let total = this.totalSum;

			if(!total) {
				return this.$t('discuss');
			}

			return 	total + " €";
		},
		currentStage() {
			const current = this.stages.find(item => item.status !== 'completed');
			return current !== -1 ? current : null;
		},
		canShowTerminate() {
			return this.status !== "failed"
				&& this.status !== "failed_with_payout"
				&& this.status !== "trash"
				&& this.status !== "completed";
		}
	},
	methods: {
		async updateRecommendedPrice() {
			if(this.orderId === -1) return;

			const res = await this.dbGetRecommendedPrice(this.orderId);
			this.recommendedPrice = res.price;
		},
		sortStages() {
			this.stages.sort((a, b) => {
				const aDate = moment(a.due_date).format("YYYY-MM-DD");
				const bDate = moment(b.due_date).format("YYYY-MM-DD");

				if(aDate > bDate) return 1;
				if(aDate < bDate) return -1;
				return 0;
			});
		},
		enableEditing() {

		}
	},
	mounted() {
		this.updateRecommendedPrice();
	}
}
</script>

<style lang="scss">
.ticket-payment-info {
	.stage {
		border-bottom: 1px solid #e4e4e4;
		padding: 15px 0;

		&__control {
			padding: 7px 10px !important;
		}

		.head {
			display: flex;
			justify-content: space-between;
			flex-wrap: wrap;
			align-items: center;
		}

		&__title {
			font-size: 18px;
		}

		&-list {
			.vs-input {
				width: 100%;
			}

			&__item {
				display: flex;
				align-items: flex-end;
				margin-top: 8px;

				.vs-input--label {
					display: flex;
				}
			}
		}

		&-info {
			display: flex;
			justify-content: space-between;
			width: 100%;
		}
	}
}
</style>
